import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { useTranslation } from 'react-i18next';

import uiHelper from '../../../helpers/ui.helper';

interface Props {
  news: any;
  onClick: () => void;
}

const HKEXNewsTimeLink: React.FC<Props> = ({ news, onClick }) => {
  const [, i18n] = useTranslation();

  return (
    <div>
      <u
        className="clickable"
        onClick={onClick}
        style={{ whiteSpace: 'nowrap' }}
      >
        <Badge bg="primary">
          {uiHelper.formatDeltaDateTime(
            i18n,
            new Date(news.ReleaseTime * 1000)
          )}
        </Badge>{' '}
        {news.ShortTitle}
      </u>
    </div>
  );
};

export default HKEXNewsTimeLink;
